export const RECENT_ACTIVITIES_CARD_TYPES = {
  action: 16,
  meeting: 2,
  eventMeeting: 8,
};
